import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "picture-error",
  "use": "picture-error-usage",
  "viewBox": "0 0 50 50",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 50 50\" id=\"picture-error\">\n    <g fill-rule=\"nonzero\" fill=\"none\">\n        <rect fill=\"#EC3342\" width=\"50\" height=\"50\" rx=\"25\" />\n        <path fill=\"#FFF\" d=\"M12 27h26v-4H12z\" />\n    </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol